import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';
import { ref, watchEffect } from 'vue';

interface Props {
  title: string;
  description?: string;
  icon?: Icons;
  collapseIcon?: Icons;
  noPaddingInBody?: boolean;
  disabled?: boolean;
  opened?: boolean;
}

interface Emits {
  (e: 'toggle', value: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcDropdownLarge.ts',
  props: {
    title: null,
    description: { default: '' },
    icon: null,
    collapseIcon: { default: 'arrowDown' },
    noPaddingInBody: { type: Boolean },
    disabled: { type: Boolean, default: false },
    opened: { type: Boolean, default: false }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'toggle', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, description: string, icon?: Icons, collapseIcon: Icons, noPaddingInBody?: boolean, disabled: boolean, opened: boolean };





const localOpened = ref<boolean>(false);

watchEffect(() => {
  localOpened.value = props.opened;
});

function handleOpen() {
  if (props.disabled) return;
  localOpened.value = !localOpened.value;
  emits('toggle', localOpened.value);
}

return { __sfc: true,emits, props, localOpened, handleOpen, CcIcon }
}

})